export const redeemTranslations = {
  en: {
    'redeem.authSuccess': 'Authentication Successful',
    'redeem.processing': 'Processing your token redemption...',
    'redeem.loading': 'Loading...',
    'redeem.redemptionComplete': 'Redemption Complete',
    'redeem.redemptionCompleteDesc': 'Your token has been successfully redeemed!',
    'redeem.backToHome': 'Back to Home',
    'redeem.processingCode': 'Processing token redemption for code: {code}',
    'redeem.noCode': 'No token code provided. Please enter your token code manually.',
    'redeem.processingRequest': 'Processing your request...',
  },
  es: {
    'redeem.authSuccess': 'Autenticación Exitosa',
    'redeem.processing': 'Procesando el canje de tu token...',
    'redeem.loading': 'Cargando...',
    'redeem.redemptionComplete': 'Canje Completo',
    'redeem.redemptionCompleteDesc': '¡Tu token ha sido canjeado exitosamente!',
    'redeem.backToHome': 'Volver al Inicio',
    'redeem.processingCode': 'Procesando el canje del token para el código: {code}',
    'redeem.noCode': 'No se proporcionó ningún código de token. Por favor, introduce tu código de token manualmente.',
    'redeem.processingRequest': 'Procesando tu solicitud...',
  },
  fr: {
    'redeem.authSuccess': 'Authentification réussie',
    'redeem.processing': 'Traitement de votre utilisation du token...',
    'redeem.loading': 'Chargement...',
    'redeem.redemptionComplete': 'Utilisation terminée',
    'redeem.redemptionCompleteDesc': 'Votre token a été utilisé avec succès !',
    'redeem.backToHome': 'Retour à l\'accueil',
    'redeem.processingCode': 'Traitement de l\'utilisation du token pour le code : {code}',
    'redeem.noCode': 'Aucun code de token fourni. Veuillez entrer votre code de token manuellement.',
    'redeem.processingRequest': 'Traitement de votre demande...',
  },
  sq: {
    'redeem.authSuccess': 'Autentifikimi i suksesshëm',
    'redeem.processing': 'Duke përpunuar shlyerjen tuaj të tokenit...',
    'redeem.loading': 'Duke ngarkuar...',
    'redeem.redemptionComplete': 'Shlyerja e përfunduar',
    'redeem.redemptionCompleteDesc': 'Tokeni juaj është shlyer me sukses!',
    'redeem.backToHome': 'Kthehu në shtëpi',
    'redeem.processingCode': 'Duke përpunuar shlyerjen e tokenit për kodin: {code}',
    'redeem.noCode': 'Nuk u dha kod tokeni. Ju lutem vendosni kodin tuaj të tokenit manualisht.',
    'redeem.processingRequest': 'Duke përpunuar kërkesën tuaj...',
  },
  ru: {
    'redeem.authSuccess': 'Аутентификация успешна',
    'redeem.processing': 'Обработка вашего погашения токена...',
    'redeem.loading': 'Загрузка...',
    'redeem.redemptionComplete': 'Погашение завершено',
    'redeem.redemptionCompleteDesc': 'Ваш токен успешно погашен!',
    'redeem.backToHome': 'Вернуться на главную',
    'redeem.processingCode': 'Обработка погашения токена для кода: {code}',
    'redeem.noCode': 'Код токена не предоставлен. Пожалуйста, введите код токена вручную.',
    'redeem.processingRequest': 'Обработка вашего запроса...',
  },
  pt: {
    'redeem.authSuccess': 'Autenticação Bem-sucedida',
    'redeem.processing': 'Processando o resgate do seu token...',
    'redeem.loading': 'Carregando...',
    'redeem.redemptionComplete': 'Resgate Concluído',
    'redeem.redemptionCompleteDesc': 'Seu token foi resgatado com sucesso!',
    'redeem.backToHome': 'Voltar para Início',
    'redeem.processingCode': 'Processando resgate de token para código: {code}',
    'redeem.noCode': 'Nenhum código de token fornecido. Por favor, insira seu código de token manualmente.',
    'redeem.processingRequest': 'Processando sua solicitação...',
  },
  de: {
    'redeem.authSuccess': 'Authentifizierung erfolgreich',
    'redeem.processing': 'Ihre Token-Einlösung wird verarbeitet...',
    'redeem.loading': 'Wird geladen...',
    'redeem.redemptionComplete': 'Einlösung abgeschlossen',
    'redeem.redemptionCompleteDesc': 'Ihr Token wurde erfolgreich eingelöst!',
    'redeem.backToHome': 'Zurück zur Startseite',
    'redeem.processingCode': 'Token-Einlösung für Code wird verarbeitet: {code}',
    'redeem.noCode': 'Kein Token-Code bereitgestellt. Bitte geben Sie Ihren Token-Code manuell ein.',
    'redeem.processingRequest': 'Ihre Anfrage wird verarbeitet...',
  },
  ro: {
    'redeem.authSuccess': 'Autentificare Reușită',
    'redeem.processing': 'Procesare răscumpărare token...',
    'redeem.loading': 'Se încarcă...',
    'redeem.redemptionComplete': 'Răscumpărare Completă',
    'redeem.redemptionCompleteDesc': 'Token-ul dvs. a fost răscumpărat cu succes!',
    'redeem.backToHome': 'Înapoi la Acasă',
    'redeem.processingCode': 'Procesare răscumpărare token pentru cod: {code}',
    'redeem.noCode': 'Niciun cod token furnizat. Vă rugăm să introduceți codul token manual.',
    'redeem.processingRequest': 'Procesare cerere dvs...',
  },
  sr: {
    'redeem.authSuccess': 'Аутентификација успешна',
    'redeem.processing': 'Обрада вашег откупа токена...',
    'redeem.loading': 'Учитавање...',
    'redeem.redemptionComplete': 'Откуп завршен',
    'redeem.redemptionCompleteDesc': 'Ваш токен је успешно откупљен!',
    'redeem.backToHome': 'Назад на почетну',
    'redeem.processingCode': 'Обрада откупа токена за код: {code}',
    'redeem.noCode': 'Није дат код токена. Молимо унесите ваш код токена ручно.',
    'redeem.processingRequest': 'Обрада вашег захтева...',
  },
  pl: {
    'redeem.authSuccess': 'Uwierzytelnianie Zakończone Sukcesem',
    'redeem.processing': 'Przetwarzanie wykorzystania Twojego tokena...',
    'redeem.loading': 'Ładowanie...',
    'redeem.redemptionComplete': 'Wykorzystanie Zakończone',
    'redeem.redemptionCompleteDesc': 'Twój token został pomyślnie wykorzystany!',
    'redeem.backToHome': 'Powrót do Strony Głównej',
    'redeem.processingCode': 'Przetwarzanie wykorzystania tokena dla kodu: {code}',
    'redeem.noCode': 'Nie podano kodu tokena. Proszę wprowadzić kod tokena ręcznie.',
    'redeem.processingRequest': 'Przetwarzanie Twojego żądania...',
  },
  el: {
    'redeem.authSuccess': 'Επιτυχής Πιστοποίηση',
    'redeem.processing': 'Επεξεργασία της εξαργύρωσης του διακριτικού σας...',
    'redeem.loading': 'Φόρτωση...',
    'redeem.redemptionComplete': 'Εξαργύρωση Ολοκληρώθηκε',
    'redeem.redemptionCompleteDesc': 'Το διακριτικό σας έχει εξαργυρωθεί με επιτυχία!',
    'redeem.backToHome': 'Επιστροφή στην Αρχική',
    'redeem.processingCode': 'Επεξεργασία εξαργύρωσης διακριτικού για κωδικό: {code}',
    'redeem.noCode': 'Δεν παρέχεται κωδικός διακριτικού. Παρακαλώ εισάγετε τον κωδικό διακριτικού σας χειροκίνητα.',
    'redeem.processingRequest': 'Επεξεργασία του αιτήματός σας...',
  },
};
